var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"supporter-results",class:{
    'is-loading': _vm.isLoading,
    'supporter-results--affiliate': !_vm.isDefaultAffiliate,
  }},[(_vm.showSubmissionView)?[_c('Submission',{attrs:{"submission":_vm.submission,"show-notification":_vm.isLoggedSubmissionFlow}})]:[_c('ResultsBoard'),_c('FeaturesShowcase')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }